module.exports = __webpack_public_path__ + "media/images/facebook-1-9ca669f40ca1f29645a25e5cb3853f5c.png";